import Repository from '@/repositories/base/Repository';

export default class HubSpotRepository extends Repository {
  public async getInnCashUserHubSpotToken(companyGroupId: number): Promise<string> {
    const { data: response } = await this.datasource.get(
      `company-groups/${companyGroupId}/hub-spot/auth-user`,
      {},
    );

    return response.data.hub_spot_token;
  }
}
